import React from 'react';
import CopyableText from '../shared/CopyableText';

const ellipsis = {
    maxWidth: '320px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

/** Colunas alinhadas a CostCenterEmployee (id, name, email). */
export const COST_CENTER_EMPLOYEE_LIST_COLUMNS = [
    {
        header: 'ID',
        accessor: 'id',
        sortable: false,
        render: (item) => (item?.id != null ? String(item.id) : '—'),
    },
    {
        header: 'Nome',
        accessor: 'name',
        sortable: false,
        render: (item) => (
            <div style={ellipsis} title={item?.name || undefined}>
                {item?.name || '—'}
            </div>
        ),
    },
    {
        header: 'E-mail',
        accessor: 'email',
        sortable: false,
        render: (item) => <CopyableText text={item?.email} />,
    },
];
